module.exports = __webpack_public_path__ + "static/logo-with-title-70f70701ce728a92abc9b35b2a65a3df.png";